module.exports = {
  supportedCountryCodes: ['uae', 'gr', 'sa'],
  countriesLanguages: {
    uae: ['en'],
    gr: ['en', 'el'],
    sa: ['en', 'ar']
  },
  googleApiKey: 'AIzaSyCcsLOyCRKa_PIH_DwVDEgs-s1EUWhOg1A',
}